import React, { SVGProps } from "react";

const SelectorChevron: React.FC<SVGProps<SVGSVGElement>> = (props) => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d={
					"M3.27545 6.27576C2.90817 6.64231 2.90817 7.22878 3.27545 7.59533L9.47244 13.7801C9.76624 14.0733 10.2337 14.0733 10.5275 13.7801L16.7245 7.59533C17.0918 7.22878 17.0918 6.64\
231 16.7245 6.27576C16.3572 5.9092 15.7696 5.9092 15.4023 6.27576L9.99334 11.6674L4.58435 6.26908C4.22375 5.9092 3.62937 5.9092 3.26877 6.27576H3.27545Z"
				}
			/>
		</svg>
	);
};

export default SelectorChevron;
